export const baseUrl = process.env.REACT_APP_BASE_URL;
export const wsBaseUrl = process.env.REACT_APP_WS_BASE_URL;
export const firbaseApiKey = process.env.REACT_APP_FIREBASE_API_KEY;

// should be an env variable
export const TIME_OUT = 300000; // 5 minutes
